import InteresCrud from './InteresCrud'
export {InteresCrud}
export default InteresCrud
